export default {
    labels: [
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],
    items: [
        {
            label: 'Downy',
            data: [717, 635, 772, 651, 755, 785],
            palette: 'primary',
            pointStyle: 'circle'
        },
        {
            label: 'Pigeon',
            data: [507, 605, 618, 523, 540, 627],
            palette: 'secondary',
            pointStyle: 'rect'
        },
        {
            label: 'Saffron',
            data: [377, 310, 374, 387, 400, 324],
            palette: 'error',
            pointStyle: 'triangle'
        },
        {
            label: 'ATO Safe',
            data: [269, 206, 280, 260, 279, 281],
            palette: 'info',
            pointStyle: 'crossRot'
        },
        {
            label: 'Consensus',
            data: [155, 113, 130, 173, 152, 182],
            palette: 'success',
            pointStyle: 'star'
        }
    ]
};
